import { Card, Row, Col, CardBody } from "react-bootstrap";
import { Avatar,Button,Flex  } from "antd";
import { green, blue, red } from '@ant-design/colors';

const categories = [
  {id:1,category:'Mujeres Líderes'},
  {id:2,category:'Verdades Ocultas'},
  {id:3,category:'Agenda Sheinbaum'},
  {id:4,category:'La Ciudad'},
  {id:5,category:'México Regional'},
  {id:6,category:'Crimen y Poder'},
  {id:7,category:'Voces y Opiniones'},
  {id:8,category:'Economía al Día'},
  {id:9,category:'Deportes al Instante'},
  {id:10,category:'Entretenimiento'},
  {id:11,category:'Cultura Viva'},
  {id:12,category:'Diálogos Abiertos'},
  {id:13,category:'Lo Último'},
  {id:14,category:'Salud y Ciencia'},
  {id:15,category:'Última Hora'},
  {id:16,category:'México Hoy'}
];

const myColors =["primary","danger","blue","purple","cyan","green","magenta","pink","red","orange","yellow","volcano","geekblue","lime","gold"];

export default function CustomerHeaderComponent({data}){
  return(
    <Col md={12} className="cdp-component">
      <Card>
        <CardBody>        
          <Row>
          <Col md={6}>
            <div className="d-flex align-items-center mb-2">              
              {/*<img className="avatar image-profile" src="/assets/img/user-profile.png" alt="img" />*/}
              <Avatar
                shape="square"
                size={{ xs: 85, sm: 80, md: 90, lg: 95, xl: 98, xxl: 100 }}
                src='/assets/img/user-profile.png'
              />
              <div>
                <h5 className="mb-1">{data.lastname}</h5>
                <p className="mb-2">{data.uid}</p>
                <div className="d-flex align-items-center">
                  <span className="badge bg-dark bg-light-600 text-default me-3" style={{textTransform:'uppercase'}}>
                    <i className="ti ti-lock me-1" ></i>{data.type}
                  </span>
                  {/*
                  <p className="d-inline-flex align-items-center mb-0">
                    <i className="fa-solid fa-star text-warning me-1"></i> 5.0
                  </p>
                  */}
                </div>
              </div>
            </div>
          </Col>  
          <Col md={6}>
            <div className="customer-categories d-flex flex-wrap gap-2 mt-2 mt-md-0">              
              <Flex gap="small" wrap>
                {categories.slice(0,7).map((item,index)=>(                  
                  <Button key={index} className="fs-7" color={myColors[index]} variant="filled">{item.category}</Button>
                ))}
              </Flex>              
            </div>
          </Col>
          </Row>
        </CardBody>        
      </Card>
    </Col>  
  )
}